import { render, staticRenderFns } from "./userRecords.vue?vue&type=template&id=8592b90c&scoped=true"
import script from "./userRecords.vue?vue&type=script&lang=js"
export * from "./userRecords.vue?vue&type=script&lang=js"
import style0 from "./userRecords.vue?vue&type=style&index=0&id=8592b90c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8592b90c",
  null
  
)

export default component.exports